import React from "react";
import ReactDOM from "react-dom";
import authentication from "react-azure-b2c";

export function redirect(policy) {
  authentication.initialize({
    instance: process.env.REACT_APP_AUTH_INSTANCE,
    tenant: process.env.REACT_APP_AUTH_TENANT,
    signInPolicy: policy,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    cacheLocation: process.env.REACT_APP_AUTH_CACHE_LOCATION,
    scopes: [
      process.env.REACT_APP_AUTH_SCOPES,
    ],
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
    postLogoutRedirectUri: window.location.origin,
  });

  authentication.run(() => {
    ReactDOM.render(<></>, document.getElementById("root"));
  });
}
